{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Stack Maps ID",
      "folder": "Disposition Header",
      "tnum": true,
    },
  },
  "disposition_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Disposition No.",
      "folder": "Disposition Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Disposition Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "disposition_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "document_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Document Type",
      "folder": "Disposition Header",
      "isShownByDefault": true,
    },
  },
  "discrepancy_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Discrepancy",
      "folder": "Disposition Header",
    },
  },
  "cancellation_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Cancellation Date",
      "folder": "Dates",
      "isShownByDefault": true,
    },
  },
  "edit_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Edit Date",
      "folder": "Dates",
    },
  },
  "process_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Process Date",
      "folder": "Dates",
    },
  },
  "version_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Version Date",
      "folder": "Dates",
    },
  },
  "notification_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Notification Date",
      "folder": "Dates",
    },
  },
  "site_entry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Site Entry Date",
      "folder": "Dates",
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
